import axios from "axios";
import React, { useState, useEffect } from "react";
import Select from "react-select";

const CustomSelect2 = ({
  type,
  value,
  onChange,
  placeholder,
  name,
  id,
  disabled,
  hidden,
}) => {
  const [subCategory, setSubCategory] = useState();
  const [selectedCategory, setSelectedCategory] = useState();

  const SubCategoryList = () => {
    axios
      .post(
        `https://app1.crazzyhub.com/business-sub-category-list-data/`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        setSubCategory(response.data.business_sub_category_list);
        // toast.success(response.data.message);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        // alert(error.message);
      });
  };
  useEffect(() => {
    SubCategoryList();
  }, []);

  console.log("Sub Category", subCategory);
  const options =
    subCategory &&
    subCategory.map(function (category) {
      return { value: category.id, label: category.name };
    });
  console.log(selectedCategory);
  return (
    <>
      <Select
        isMulti
        options={options}
        id={id}
        name={name}
        type={type}
        disabled={disabled}
        hidden={hidden}
        value={selectedCategory}
        onChange={setSelectedCategory}
        placeholder={placeholder}
      />
    </>
  );
};

export default CustomSelect2;
